// extracted by mini-css-extract-plugin
export default {"component":"gh7Hv","text":"Tvzp9"};